import { put } from 'typed-redux-saga';

import { closeSettingsModal } from '../../../shared/features/settings-modal/slice';
import { resetBroadcastState } from '../features/broadcast/slice';
import { resetChatState } from '../features/chat';
import { resetCloudRecordingState } from '../features/cloud-recording';
import { resetConferenceState } from '../features/conference/slice';
import { resetDeviceState } from '../features/device/slice';
import { resetFullscreen } from '../features/fullscreen';
import { resetVideoGrid } from '../features/goloom-video-grid';
import { resetNetworkQuality } from '../features/network-quality/slice';
import { resetOfflineState } from '../features/offline/slice';
import { resetPermissions } from '../features/permissions';
import { resetRecordState } from '../features/record';
import { resetScreenSharing } from '../features/screen-sharing/slice';
import { resetShareLink } from '../features/share-link/slice';
import { resetSidebar } from '../features/sidebar/slice';
import { resetSummarizationState } from '../features/summarization';
import { resetWaitingRooms } from '../features/waiting-rooms/slice';
import { resetMessengerState } from '../iframe-sagas/slice';

export const resetCallSaga = function* () {
    yield* put(resetConferenceState());
    yield* put(resetBroadcastState());
    yield* put(resetChatState());
    yield* put(resetDeviceState());
    yield* put(resetFullscreen());
    yield* put(resetVideoGrid());
    yield* put(resetNetworkQuality());
    yield* put(resetOfflineState());
    yield* put(resetPermissions());
    yield* put(resetScreenSharing());
    yield* put(resetShareLink());
    yield* put(resetSidebar());
    yield* put(resetWaitingRooms());
    yield* put(resetRecordState());
    yield* put(resetMessengerState());
    yield* put(resetSummarizationState());
    yield* put(resetCloudRecordingState());
    yield* put(closeSettingsModal());
};
